/**
 * Verwaltung / landlord one-line summaries: join only real values with " — ".
 * Treats literal "—" / "-" placeholders as empty so we never show "Zürich — — —".
 */

export function normalizeLandlordDisplayPart(value) {
  const t = String(value ?? "").trim();
  if (!t) return "";
  if (t === "—" || t === "–" || t === "-") return "";
  return t;
}

/**
 * @param {object|null|undefined} l Landlord row
 * @returns {string}
 */
export function formatLandlordSummaryLine(l) {
  if (!l) return "—";
  const norm = normalizeLandlordDisplayPart;
  const raw = [
    norm(l.company_name),
    norm(l.contact_name),
    norm(l.email),
    norm(l.phone),
    norm(l.city),
  ].filter(Boolean);
  const parts = [];
  const seen = new Set();
  for (const p of raw) {
    if (seen.has(p)) continue;
    seen.add(p);
    parts.push(p);
  }
  if (parts.length > 0) return parts.join(" — ");
  const id = l.id != null ? String(l.id).trim() : "";
  return id || "—";
}

/**
 * Compact one-line landlord label for narrow table cells.
 * Falls back through company_name → contact_name → id → "—".
 * @param {object|null|undefined} l Landlord row
 * @returns {string}
 */
export function formatLandlordCompactLabel(l) {
  if (!l) return "—";
  const norm = normalizeLandlordDisplayPart;
  const company = norm(l.company_name);
  if (company) return company;
  const contact = norm(l.contact_name);
  if (contact) return contact;
  const id = l.id != null ? String(l.id).trim() : "";
  return id || "—";
}
